import type { CSSObject, Transformer } from '@ant-design/cssinjs';
import { px2remTransformer } from '@ant-design/cssinjs';

/**
 * The properties that follow the text-size preference. Line heights stay
 * out: antd's text line heights are unitless, and its px ones are derived
 * from control heights (tree rows, pagination, switches), which stay px.
 */
const TYPE_KEYS = ['fontSize', 'letterSpacing'] as const;

/**
 * Turns Ant Design's typography px into rem, so its text follows the root
 * font size that the text-size preference sets (tokens.css). Everything else
 * stays in px, as in the kit, where only font sizes are multiplied by --ts:
 * control heights (44 / 36 px touch targets), paddings and radii keep their
 * size at Small and Large text.
 */
export const typeRemTransformer = (rootValue = 16): Transformer => {
  const rem = px2remTransformer({ rootValue });
  return {
    visit: (cssObj: CSSObject) => {
      const typography: CSSObject = {};
      let found = false;
      for (const key of TYPE_KEYS) {
        if (key in cssObj) {
          typography[key] = cssObj[key];
          found = true;
        }
      }
      if (!found || !rem.visit) return cssObj;
      return { ...cssObj, ...rem.visit(typography) };
    },
  };
};
